import React from 'react';
import styled from 'styled-components';
import { uniqueId } from 'lodash';
import { WEEKDAYS } from '../../constants/date.contant';
import { useTranslation } from 'react-i18next';

const Weekday = styled.span`
  padding: 8px 0;
  flex: 1;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
`;
const Weekend = styled(Weekday)`
  color: ${({ theme }) => theme.colors.RED.R400};
`;
const StyledDatePickerWeekend = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.NEUTRAL.N300};
`;

const DatePickerWeekendComponent = () => {
  const { t } = useTranslation();
  
  const weekdayTitles = WEEKDAYS.map((day: string, index: number) => {
    if (index > 4) {
      return <Weekend key={uniqueId('weekday_')}>{t(`weekdays.${day}`)}</Weekend>;
    }
    return <Weekday key={uniqueId('weekday_')}>{t(`weekdays.${day}`)}</Weekday>;
  });
  
  return <StyledDatePickerWeekend>{weekdayTitles}</StyledDatePickerWeekend>;
};

export default DatePickerWeekendComponent;
